import type {
    EasyTradeInCharacteristic,
    EasyTradeInEligibility,
    EasyTradeInEligibilityResponse,
    EasyTradeInProductApi,
    EasyTradeInResult,
} from '@app-types/easy-trade-in';
import { EasyTradeInStatus } from '@app-types/easy-trade-in';

import {
    CLASSIC_TRADE_IN_SUB_TYPE,
    EASY_TRADE_IN_MAX_CREDIT_TO_RECYCLE,
    EASY_TRADE_IN_SUB_TYPE,
} from '@constants/easy-trade-in';

function getCharacteristic(characteristics: EasyTradeInCharacteristic[] | undefined, type: string): string | undefined {
    return characteristics?.find((characteristic) => characteristic.typeCaracteristique === type)?.valeur;
}

function statusFromRemainingCredit(finalPrice: number, remainingCredit: number): EasyTradeInStatus {
    if (finalPrice > -EASY_TRADE_IN_MAX_CREDIT_TO_RECYCLE) {
        return EasyTradeInStatus.TOO_LOW;
    }
    if (remainingCredit === 0) {
        return EasyTradeInStatus.SETTLED;
    }
    return EasyTradeInStatus.PARTIAL;
}

export class EasyTradeInMapper {
    static apiToEligibility(response: EasyTradeInEligibilityResponse): EasyTradeInEligibility {
        const classicProduct = response.produits.find((product) => product.sousType === CLASSIC_TRADE_IN_SUB_TYPE);
        const easyProduct = response.produits.find((product) => product.sousType === EASY_TRADE_IN_SUB_TYPE);

        return {
            hasClassicTradeIn: !!classicProduct,
            hasEasyTradeIn: !!easyProduct,
            partnerProductId: getCharacteristic(easyProduct?.caracteristiques, 'ID_PRODUIT_PARTENAIRE'),
            creditId: getCharacteristic(easyProduct?.caracteristiques, 'ID_FINANCEMENT_SOUSCRIT'),
        };
    }

    static apiToResult(easyProduct: EasyTradeInProductApi): EasyTradeInResult {
        const characteristics =
            easyProduct?.ressourcesAttribuees?.find((ressource) => ressource.typeRessource === 'PARTENAIRE')
                ?.caracteristiques ?? [];

        const remainingCredit = Number.parseFloat(getCharacteristic(characteristics, 'CRD_APRES_REPRISE') ?? '0');
        const remainingCreditTerminal = Number.parseFloat(
            getCharacteristic(characteristics, 'CRD_TERMINAL_APRES_REPRISE') ?? '0',
        );
        const creditBeforeTradeIn = Number.parseFloat(getCharacteristic(characteristics, 'CRD_TERMINAL') ?? '0');

        const estimatedValue = easyProduct.prix?.final ?? 0;

        const creditAccessories = Number.parseFloat(getCharacteristic(characteristics, 'CRD_AUTRE') ?? '0');
        const creditOtherAfterTradeIn = Number.parseFloat(
            getCharacteristic(characteristics, 'CRD_AUTRE_APRES_REPRISE') ?? '0',
        );

        return {
            status: statusFromRemainingCredit(estimatedValue, remainingCreditTerminal),
            remainingCredit,
            remainingCreditTerminal,
            creditBeforeTradeIn,
            estimatedValue,
            partnerRequestId: getCharacteristic(characteristics, 'ID_DEMANDE_PARTENAIRE'),
            creditAccessories: creditOtherAfterTradeIn > 0 ? creditAccessories : 0,
        };
    }
}
